import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Don't scroll to top if we're navigating with state that indicates
    // we want to scroll to a specific section (like comments)
    if (state?.showComments || state?.showForm) {
      return; // Let the component handle its own scrolling
    }
    
    // Scroll to top for normal navigation
    window.scrollTo(0, 0);
    
    // Track page view in Google Analytics
    trackPageView(pathname);
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
